import { useEffect, useState } from 'react';
import { useQuery } from './useQuery';

enum DefaultParams {}

// Accepts an Enum. Must "extend" string | number because TypeScript doesn't allow extending Enums.
function useFeatureFlags<Enum extends string | number = DefaultParams>(): (
  key: Enum,
  defaultValue?: boolean
) => boolean {
  // Dynamically generated to match the provided Enum
  type QueryParams = {
    [key in Enum]?: boolean;
  };

  const [featureFlags, setFeatureFlags] = useState<QueryParams>({});
  const searchParams = useQuery();

  useEffect(() => {
    setFeatureFlags(searchParams as QueryParams); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Check if a given Feature Flag is present, based on your provided Enum
  function getFeatureFlag(key: Enum, defaultValue = false): boolean {
    return !!featureFlags[key] ?? defaultValue;
  }

  return getFeatureFlag;
}

export { useFeatureFlags };
